/**
 * The presentational Voice Mode control (`VoiceModeButton`) reports toggle
 * clicks to its parent. The parent changes the session; its controller owns audio.
 */
import { Icons } from '@/assets/icons/icons';
import { RoundIconButton } from '@/design-system-v2/round-icon-button';

interface VoiceModeButtonProps {
  isActive: boolean;
  disabled: boolean;
  onToggle: () => void;
  className?: string;
}

export function VoiceModeButton({
  isActive,
  disabled,
  onToggle,
  className,
}: VoiceModeButtonProps) {
  const tooltip = isActive ? 'Stop voice mode' : 'Start voice mode';

  return (
    <RoundIconButton
      size="sm"
      className={className}
      icon={isActive ? Icons.cancel : Icons.dictation}
      active={isActive}
      onClick={onToggle}
      disabled={disabled}
      label={tooltip}
      aria-pressed={isActive}
      data-testid="voice-mode-button"
    />
  );
}
